import React from 'react';
import AssetTeamNavBar from '../../../../../layouts/asset-team/AssetTeamNavBar';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import ExpiredGraph from './ExpiredGraph';

const ExpiredCustomersByZones = () => {
  const { profile } = useUser();
  const { firstName } = profile;

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <AssetTeamNavBar currentPage="Expired Customers Per Zone" position={firstName} />
        <div className="mt-5">
          <ExpiredGraph />
        </div>
      </main>
    </div>
  );
};

export default ExpiredCustomersByZones;
